import { type MeResponse, type ResearchRecord, hasPermission } from "@pokifolio/contracts";

export interface Allowed {
  readonly allowed: boolean;
  /** Why not, in plain words; null when allowed. */
  readonly reason: string | null;
}

const yes: Allowed = { allowed: true, reason: null };
const no = (reason: string): Allowed => ({ allowed: false, reason });

/** The owner may change their own research; others need "edit any research" (same as the server). */
function mayChange(record: ResearchRecord, me: MeResponse): boolean {
  return (
    hasPermission(me.permissions, "research.update_any") ||
    (record.owner.id === me.user.id && hasPermission(me.permissions, "research.update_own"))
  );
}

/** Same as the server's checkClose: only shows or hides the button; the server decides. */
export function closeRule(record: ResearchRecord, me: MeResponse): Allowed {
  if (!hasPermission(me.permissions, "research.approve") && !mayChange(record, me))
    return no(`Only ${record.owner.name}, who saved this, can close it.`);
  if (record.status === "closed") return no("This research is already closed.");
  if (record.status === "waiting_approval") return no("Withdraw the request before closing this research.");
  return yes;
}

/** Same as the server's checkDelete (D-58). */
export function deleteRule(record: ResearchRecord, me: MeResponse): Allowed {
  if (record.status === "approved")
    return no("Approved research is the record of a purchase decision and cannot be deleted.");
  if (hasPermission(me.permissions, "research.approve")) return yes;
  if (!mayChange(record, me)) return no(`Only ${record.owner.name}, who saved this, can delete it.`);
  if (record.status === "waiting_approval") return no("Withdraw the request before deleting this research.");
  if (record.status === "rejected") return no("Close this rejected research before deleting it.");
  return yes;
}
